import type { ComponentProps } from '@exodus/exchange-ui/lib/form/components/percentage-switch';
import { useValidationContext } from '@exodus/exchange-ui/lib/form/context/validation';
import SegmentedControl from '@passkeys/ui/segmented-control';
import { useMemo } from 'react';

function PercentageSwitch({
  value,
  loading,
  options,
  className,
  onChange,
}: ComponentProps) {
  const activeIndex = options.findIndex((option) => option.id === value);

  const { currentError } = useValidationContext();
  const disabled = currentError?.reason === 'PAIR_UNAVAILABLE' || loading;

  const segments = useMemo(() => {
    return options.map((option) => ({
      label: option.label,
      onClick: () => {
        onChange(option.id);
      },
    }));
  }, [onChange, options]);

  return (
    <SegmentedControl
      activeIndex={activeIndex >= 0 ? activeIndex : undefined}
      segments={segments}
      disabled={disabled}
      className={className}
    />
  );
}

export default PercentageSwitch;
